<template>
    <v-card>
        <template v-if="resource.type == 0">
            <v-img
                position="top center"
                height="450"
                :src="`${baseImageUrl}${resource.image}`"
            ></v-img>
            <v-card-title v-text="resource.title"></v-card-title>
            <v-card-text>
                <div 
                    class="mb-6 subtitle-1" 
                    v-text="subjectFormatted"
                    v-if="subjectFormatted"
                ></div>
                <div v-text="resource.description"></div>
            </v-card-text>
        </template>
        <template v-else-if="resource.type == 1">
            <v-card-title v-text="resource.title"></v-card-title>
            <v-card-text>
                <div 
                    class="mb-6 subtitle-1" 
                    v-text="subjectFormatted"
                    v-if="subjectFormatted"
                ></div>
                <div class="body-1 mb-4" v-text="resource.description"></div>
                <v-btn rounded depressed color="primary" target="_blank" :href="`${baseImageUrl}${resource.file}`">
                    <v-icon left>mdi-attachment</v-icon> {{ resource.documentTitle }}
                </v-btn>
            </v-card-text>
        </template>
        <template v-else-if="resource.type == 2">
            <div class="iframe-container" v-if="iframeSrc">
                <iframe 
                    width="1280" 
                    height="720" 
                    :src="iframeSrc" 
                    frameborder="0" 
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
                ></iframe>
            </div>
            <div class="iframe-container" v-else>Not a valid url</div>
        </template>
    </v-card>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'resourceCardDetails',
        props: {
            resource: {
                type: Object,
                default: () => ({
                    id: 0,
                    type: null,
                    description: '',
                    documentTitle: '',
                    file: '',
                    image: '',
                    title: '',
                    videoLink: ''
                })
            }
        },
        computed: {
            ...mapGetters(['baseImageUrl']),
            subjectFormatted() {
                if(this.resource.teachingSubject) {
                    return `${this.resource.teachingSubject.name}(${this.resource.educationLevel.name})`
                }
                return
            },
            iframeSrc() {
                if (this.resource.videoLink.indexOf('youtube.com') !== -1) {
                    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
                    var match = this.resource.videoLink.match(regExp)

                    if(match && match[7].length == 11) {
                        return `https://www.youtube.com/embed/${match[7]}`
                    } else {
                        return false
                    }
                }else if (this.resource.videoLink.indexOf('vimeo.com') !== -1) {
                    var regExp = /(?:vimeo)\.com.*(?:videos|video|channels|)\/([\d]+)/i;
                    var match = this.resource.videoLink.match(regExp);
                    return `https://player.vimeo.com/video/${match[1]}`
                }
                return this.resource.videoLink
            }
        },
        beforeMount() {
            this.iframeSrc = ''
        }
    }
</script>

<style lang="scss" scoped>
.iframe-container{
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
}
iframe{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
}
.image-container{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 255px;
    background-color: #f5f5f5;
    img{
        max-width: 100%;
        max-height: 300px;
        vertical-align: middle;
    }
}
</style>